import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import backgroundImage from '../assets/images/aircraft-fix/bg.png'
import foregroundImage from '../assets/images/aircraft-fix/fg.png'
import continueBtn from '../assets/images/aircraft-fix/continue.png'
import menuBtn from '../assets/images/aircraft-fix/menu.png';
import descImage from '../assets/images/aircraft-fix/desc.png';

import fixA from '../assets/images/aircraft-fix/fix-a.png';
import fixB from '../assets/images/aircraft-fix/fix-b.png';
import fixC from '../assets/images/aircraft-fix/fix-c.png';
import fixD from '../assets/images/aircraft-fix/fix-d.png';

const fixImages = [ fixA, fixB, fixC, fixD ]

class AircraftFix extends Component {

    btnSound = './sounds/btn1.mp3';
    backMenuSound = './sounds/back-menu.mp3';

    constructor(props) {
        super(props);
        this.state = {
            currentIndex: -1,
            continueShow: true
        };
    }
    
    next() {
        this.playBtnSound();
        this.setState({
            currentIndex: this.state.currentIndex + 1 >= fixImages.length ? this.state.currentIndex : this.state.currentIndex + 1,
            continueShow: this.state.currentIndex + 1 >= fixImages.length - 1 ? false : true
        });
    }

    goToMenuPage() {
        this.playBackMenuSound();
        this.props.history.push({
            pathname: './menu',
            state: {}
        });
    };

    playBtnSound() {
        let btnAudio = new Audio(this.btnSound);
        btnAudio.play();
    }

    playBackMenuSound() {
        let btnAudio = new Audio(this.backMenuSound);
        btnAudio.play();
    }

    render() {
        return (
            <div className='page-root-div'>
                <img alt='' src={backgroundImage} style={{ width: '100%', height: '100%', overflow: 'hidden', objectFit: 'cover', position: 'absolute' }}/>
                <img alt='' src={foregroundImage} style={{ width: '100%', left: '0%', top: '0%', position: 'absolute' }}/>
                {
                    this.state.currentIndex >= 0 && <img alt='' src={fixImages[this.state.currentIndex]} style={{ width: '100%', position: 'absolute' }}/>
                }
                {
                    this.state.currentIndex < 0 && <img alt='' src={descImage} style={{ width: '44.7%', position: 'absolute', left: '10.5%', top: '34.5%' }}/>
                }
                {
                    this.state.continueShow && (<img className='press-btn' alt='' src={continueBtn} style={{ height: '6.7%', bottom: '41%', left: '46.5%', position: 'absolute', background: 'transparent' }} onClick={this.next.bind(this)}/>)
                }
                <img className='press-btn' alt='' src={menuBtn} style={{ height: '10.3%', bottom: '5%', left: '81%', position: 'absolute', background: 'transparent' }} onClick={this.goToMenuPage.bind(this)}/>
            </div>
        )
    }
}

export default withRouter(AircraftFix);
